import useQueryWithState from "./use_query_with_state";
import loadLatestTos from "../actions/react_query/load_latest_tos";
import getLatestTos from "../services/getters/get_latest_tos";
import useAvvirSelector from "../services/component_helpers/component_effects/use_avvir_selector";
import getUser from "../services/getters/base_getters/get_user";

const useLatestTos = () => {
  const user = useAvvirSelector(getUser);
  return useQueryWithState(
    ["useLatestTos"],
    loadLatestTos,
    getLatestTos,
    {enabled: !!user},
    {},
  );
};

export default useLatestTos;
